export class SortReviews {
    dropdownMenu: HTMLSelectElement;
    options: HTMLOptionsCollection;
    constructor(dropdown: HTMLSelectElement) {
        this.dropdownMenu = dropdown;
        this.options = dropdown.options;
    }

    getSortReviews(selectIndex?: number): string {
        selectIndex = selectIndex>=0 || selectIndex!=undefined? selectIndex: this.options.selectedIndex;
        return this.options[selectIndex].value;
    }

}